class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.querySelector('.cart-closer').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {

    this.classList.contains('is-empty') && this.classList.remove('is-empty');
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


// Bundle Popup JS
function showBundlePopup(type, index = 0) {
  const cartItem = document.getElementById("CartDrawer-Item-" + index);
  const popup = document.getElementById("CartDrawer-options-" + index);
  if (popup) {
    popup.classList.add("is-active");
    popup.classList.add("type-" + type);
  }
}

// Close bundle popup
function closeBundlePopup(popupElement) {
  const popup = popupElement.closest('.bundle-popup');
  if (popup) {
    popup.classList.remove('is-active');
    popup.classList.remove('type-edit');
    popup.classList.remove('type-upgrade');
  }
}

// 1. Get what user selected from dropdowns
function getSelectedVariants(className) {
  const selects = document.querySelectorAll(className);
  const selections = [];
  let options = "";

  selects.forEach((select, index) => {
    const option = select.options[select.selectedIndex];
    // Skip if selector has only one option (one size/variant)
    if (select.options.length <= 1) {
      return;
    }
    if (option && option.value) {
      selections.push({
        variantId: option.value,
        size: option.textContent.trim(),
        productIndex: index,
      });
    }
  });

  for (let i = 0; i < selections.length; i++) {
    const sel = selections[i];
    options += sel.size;
    if (i < selections.length - 1) {
      options += " / ";
    }
  }

  return options;
}

// 2. Find the Matching Bundle variant
function findMatchingVariant(className, bundle) {
  if (!bundle || !bundle.variants) {
    console.error('Bundle or bundle variants not provided');
    return null;
  }

  const selections = getSelectedVariants(className, bundle);
  const bundleVariants = bundle.variants;
  return bundleVariants.find(variant => variant.title === selections) || null;
}

// 3. Add bundle to cart
async function addOrUpdateBundleInCart(className, bundle, urlToRemove) {
  const matchingVariant = findMatchingVariant(className, bundle);
  if (!matchingVariant) {
    console.warn("No matching variant found for selection");
    return;
  }
  try {
    await addToCart(matchingVariant.id, 1, urlToRemove);
  } catch (error) {
    console.error("❌ Failed to add bundle to cart:", error);
    throw error;
  }
}

// Add a product variant to the cart (optionally with properties and quantity)
async function addToCart(variantId, quantity = 1, urlToRemove) {
  let payload = {
    id: variantId,
    quantity: quantity,
    sections: ["cart-drawer", "cart-icon-bubble"],
  };

  const res = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!res.ok) throw new Error("Cart add failed");
  const data = await res.json();
  await removeByUrl(urlToRemove);

  return data;
}

async function removeByUrl(urlToRemove) {
  const res = await fetch(urlToRemove, { method: "GET" });
  if (!res.ok) throw new Error("Remove failed");

  // Get updated cart sections after removal
  const sectionsRes = await fetch(`/?sections=cart-drawer,cart-icon-bubble`);
  if (!sectionsRes.ok) throw new Error("Failed to get cart sections");

  const sections = await sectionsRes.json();
  if (!sections) throw new Error("No sections data found");

  const cartDrawer = {
    sections: sections,
  };
  ThatWorks.cartElement.renderContents(cartDrawer);

  return true;
}

async function handleBundleUpdate(button) {
  try {
    const selector = button.dataset.selector;
    const bundleData = JSON.parse(button.dataset.bundle);
    const urlToRemove = button.dataset.url_to_remove;
    const popup = button.closest('.bundle-popup');

    // Check if user is in edit mode and selections haven't changed
    if (popup && popup.classList.contains('type-edit')) {
      const matchingVariant = findMatchingVariant(selector, bundleData);
      
      // Check if this variant is already in cart by checking the DOM
      const isAlreadyInCart = document.querySelector(`[data-variant-id="${matchingVariant?.id}"]`);
      
      if (isAlreadyInCart) {
        // No changes made, just close the popup
        console.log("No changes detected, closing popup");
        closeBundlePopup(button);
        return;
      }
    }

    // Show loading
    button.disabled = true;
    button.querySelector("span.upgrade").textContent = "UPDATING...";
    button.querySelector("span.edit").textContent = "UPDATING...";

    await addOrUpdateBundleInCart(selector, bundleData, urlToRemove);
    
    // Close popup after successful update
    if (popup) {
      closeBundlePopup(button);
    }
  } catch (error) {
    console.error("❌ Error handling bundle update:", error);
    button.disabled = false;
    button.querySelector("span.upgrade").textContent = "UPGRADE TO BUNDLE";
    button.querySelector("span.edit").textContent = "CONFIRM CHANGES";
  }
}

// Size Chart Popup JS
function openPopup(id) {
  const popup = document.getElementById(id + '-overlay');
  if (!popup) {
    console.error(`Popup element with ID "${id}-overlay" not found`);
    return;
  }
  popup.classList.add('size-chart-popup__overlay--show');
  document.body.classList.add('overflow-hidden');
}

function closePopup(id) {
  const popup = document.getElementById(id + '-overlay');
  if (!popup) {
    console.error(`Popup element with ID "${id}-overlay" not found`);
    return;
  }
  popup.classList.remove('size-chart-popup__overlay--show');
  document.body.classList.remove('overflow-hidden');
}

function closePopupOnOverlay(e, id) {
  if (e.target === e.currentTarget) closePopup(id);
}